import { IRoute, ICrudRoute } from '@interfaces/App.interface';
import ViewPage from '@pages/DataBase/Views/ViewPage';
import Views from '@pages/DataBase/Views/Views';
//import ViewTypePage from '@pages/DataBase/ViewTypes/ViewTypePage';
//import ViewTypes from '@pages/DataBase/ViewTypes/ViewTypes';
import LayerPage from '@pages/DataBase/Layers/LayerPage';
import Layers from '@pages/DataBase/Layers/Layers';
import EventGenerationRulePage from '@pages/DataBase/EventGenerationRules/EGRPage';

import { generateCRUDRoutes } from './routes.utils';
import MapPage from '@pages/MapPage';

//#region CRUD
const crudEntitiesData: ICrudRoute[] = [
  //VIEW
  { aclId: 'taView', entityName: 'view', DataTable: Views, FormPage: ViewPage },
  //VIEW TYPE
  //{ aclId: 'taViewType', entityName: 'viewType', DataTable: ViewTypes, FormPage: ViewTypePage },
  //GEOMETRY
  //{ aclId: 'tsGeometry', entityName: 'geometry', DataTable: Geometries, FormPage: GeometryPage, customEntityName: 'geometries' },
  //LAYER
  { aclId: 'taLayer', entityName: 'layer', DataTable: Layers, FormPage: LayerPage },
];
//#endregion

//#region Maps
const mapsRoutes: IRoute[] = [
  {
    id: 'eventGenerationRuleNew',
    matchPath: '/geometry/:id/eventRule/new',
    pageComponent: EventGenerationRulePage,
    pageTitle: 'New event generation rule',
    aclId: 'taEventGenerationRule',
  },
  {
    id: 'eventGenerationRuleView',
    matchPath: '/geometry/:id/eventRule/:id/view',
    pageComponent: EventGenerationRulePage,
    pageTitle: 'View event generation rule',
    aclId: 'taEventGenerationRule',
  },
  {
    id: 'eventGenerationRuleEdit',
    matchPath: '/geometry/:id/eventRule/:id/edit',
    pageComponent: EventGenerationRulePage,
    pageTitle: 'Edit event generation rule',
    aclId: 'taEventGenerationRule',
  },
  {
    id: 'mapsView',
    matchPath: '/view/:id/map',
    pageComponent: MapPage,
    pageTitle: 'Map',
    aclId: '',
  },
];
//#endregion

export default [...mapsRoutes, ...generateCRUDRoutes(crudEntitiesData)];
